// extracted by mini-css-extract-plugin
module.exports = {"thumb":"introGuide_thumb__3Vse-"};